import { Box, styled } from '@mui/material';

export const StyledArrowRight = styled(Box)`
    width: 0;
    height: 0;
    border-left: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-right: 8px solid red;
`;
export const StyledArrowLeft = styled(Box)`
    width: 0;
    height: 0;
    border-right: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 8px solid red;
`;
export const StyledDottedBox = styled(Box)`
    width: 7px;
    border: 1px dotted red;
    border-right: 0;
    border-left: 0;
`;
export const StyledDelayStartBox = styled(Box)`
    width: 2px;
    height: 8px;
    background-color: red;
`;
export const StyledDelayOccupationBox = styled(Box)`
    width: 100%;
    height: 2px;
    background-color: red;
`;
export const StyledDeviationBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 7px;
    min-width: 10.8px; // min size of 3min delay
`;
export const StyledDeviationZone = styled(Box)`
    display: flex;
    flex-direction: row;
`;
